var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x91\x91 Edit Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9248 8.34399C19.9248 8.34399 10.1698 18.062 8.86182 19.375C10.3018 19.946 11.7798 20 11.9868 20C14.9458 20 17.4388 18.546 19.4868 16.156C20.1878 15.339 20.8008 14.466 21.2988 13.594C21.6008 13.066 21.7848 12.658 21.8928 12.406C22.0018 12.152 22.0038 11.847 21.8928 11.594C21.6658 11.074 21.2388 10.247 20.5808 9.281C20.4038 9.022 19.9248 8.34399 19.9248 8.34399Z",
    fill: "#071717",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x91\x91 Edit Color_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.987 4.00003C9.02801 3.99303 6.53501 5.45402 4.48701 7.84402C3.78601 8.66102 3.173 9.53402 2.67499 10.406C2.37299 10.934 2.189 11.342 2.081 11.594C1.973 11.845 1.973 12.155 2.081 12.406C2.189 12.658 2.37299 13.066 2.67499 13.594C3.076 14.297 3.544 15.013 4.081 15.688C4.166 15.795 4.841 16.561 5.425 17.156L4.26801 18.281C3.87801 18.672 3.87801 19.328 4.26801 19.719C4.65901 20.109 5.315 20.109 5.706 19.719L19.706 5.71902C20.096 5.32801 20.096 4.67203 19.706 4.28103C19.51 4.08603 19.243 4.00003 18.987 4.00003C18.731 4.00003 18.464 4.08603 18.268 4.28103L16.987 5.59402C15.334 4.48802 13.69 4.00403 11.987 4.00003ZM11.987 8.00002C12.505 8.00002 13.296 8.13704 14.018 8.56204L12.487 10.094C12.33 10.012 12.031 10 11.987 10C10.882 10 9.98704 10.895 9.98704 12C9.98704 12.044 9.97302 12.347 10.018 12.531C9.82602 12.764 8.51802 14.031 8.51802 14.031C8.17002 13.425 7.99101 12.694 7.98701 12C7.97601 9.79102 9.77801 8.00002 11.987 8.00002Z",
    fill: "#071717",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3fd34dc6e1cdf23a0417a2749f15a452.svg";
export { ForwardRef as ReactComponent };